module.exports = __webpack_public_path__ + "static/b1-web-7a61ebac7d5395b496bd3f664c19ed48.jpg";